export default {
  'forgot.password.title': 'Đặt lại mật khẩu',
  'forgot.password.description':
    'Vui lòng nhập địa chỉ email đã đăng kí để yêu cầu khôi phục lại mật khẩu',
  'forgot.password.notification':
    'Link khôi phục mật khẩu đã được gửi vào email của bạn. Vui lòng kiểm tra email và click vào link đã đính kèm trong mail để bắt đầu đặt lại mật khẩu.',
  'forgot.password.email': 'Email',
  'forgot.password.button.accept': 'Xác nhận',
  'forgot.password.email.not.exit': 'Email không tồn tại',
  'forgot.password.email.invalid': 'Email không phải là một email hợp lệ!',

  'forgot.password.code.title': 'Mã xác nhận',
  'forgot.recoveryCode': 'Nhập mã xác nhận',
  'forgot.desc': 'Vui lòng nhập địa chỉ email đã đăng ký để yêu cầu khôi phục lại mật khẩu',
  'forgot.text.desc':
    'Link khôi phục mật khẩu đã được gửi vào email của bạn. Vui lòng kiểm tra email và click vào link đã đính kèm trong email để bắt đầu đặt lại mật khẩu.',
  'forgot.password.username': 'Tên đăng nhập',
  'forgot.required.username': 'Vui lòng nhập tên đăng nhập',
  'forgot.required.email': 'Vui lòng nhập địa chỉ email',
};
